import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AUTH_VALIDATE_EMAIL_LINK, BUY_AGAIN } from '~shared/constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { IAccountInformation } from '~shared/models';
import { OrderHistoryApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { GaTrackingEventAction, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';

@Component({
  selector: 'app-header-buy-again',
  templateUrl: './header-buy-again.component.html',
  styleUrls: ['./header-buy-again.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBuyAgainComponent implements OnInit, OnDestroy {
  @Output() onClick = new EventEmitter<boolean>();
  @Input() user: IAccountInformation;
  isMobile: boolean;
  public readonly buyAgainLink = BUY_AGAIN;
  public readonly validateEmailLink = `${AUTH_VALIDATE_EMAIL_LINK}?backUrl=${this.buyAgainLink}`;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private mediaObserver: MediaObserver,
    private applicationEventService: ApplicationEventService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.initMediaObserver();
  }

  hideMenuAndSendGABuyAgainEvent(): void {
    this.sendGAEventBuyAgain();
    this.onClick.emit(true);
  }

  private sendGAEventBuyAgain(): void {
    this.applicationEventService.publish(
      new OrderHistoryApplicationEvent({
        event: GaTrackingEventName.BuyAgainHeaderInteraction,
        action: GaTrackingEventAction.BuyAgainHeader,
        label: null,
      })
    );
  }

  private initMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
        this.cd.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
